import FillWithMargin from "../Components/FillWithMargin";

export default function FileNotFound() {
  return (
    <FillWithMargin>
      <p style={{ textAlign: "center" }}>404 File not found.</p>
    </FillWithMargin>
  );
}
